// extracted by mini-css-extract-plugin
export default {"foregroundImageContainer":"foregroundImageContainer__tw5PG","foregroundImage":"foregroundImage__Y0NJl"};